import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";
import { getServiceSlice } from "../../../store/slices/serviceSlice";
import Card from "react-bootstrap/Card";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoEyeSharp } from "react-icons/io5";
import { FaPencilAlt } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import {
  createReferrerList,
  deleteReferrerList,
  getAllReferrerList,
  resetReferrerListCreateMessage,
  resetReferrerListDeleteMessage,
  resetReferrerListUpdateMessage,
  updateReferrerList,
  setCurrentPage,
  setPageLimit,
} from "../../../store/slices/referrerList";
import ViewReferrerList from "./ViewReferrerList";
import AddUpdateReferrerList from "./AddUpdateReferrerList";
import styles from "./referrerList.module.scss";
import { getAllUsers } from "../../../store/slices/userSlice";
import CardPagination from "../../common/pagination/cardPagination";

const ReferrerList = () => {
  const [showModals, setshowModals] = useState(false);
  const [selectId, setSelectId] = useState(null);
  const [isMode, setIsMode] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [visibleDropdown, setVisibleDropdown] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const { services } = useSelector((state) => state.service);
  const { userInfo } = useSelector((state) => state.auth);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const dispatch = useDispatch();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const {
    referrerList,
    currentPage,
    totalPages,
    totalCount,
    limit,
    createReferrerListSuccessMessage,
    createReferrerListErrorMessage,
    updateReferrerListSuccessMessage,
    updateReferrerListErrorMessage,
    deleteReferrerListSuccessMessage,
    deleteReferrerListErrorMessage,
    searchMessage,
  } = useSelector((state) => state.referrerList);
  const clinicId = clinicInfo?.[0]?.clinicId || null;
  const { token } = useSelector((state) => state.auth);
  const initialState = {
    name: "",
    email: "",
    phone: "",
    status: "Active",
    referalDetails: [
      {
        serviceId: "",
        serviceName: "",
        referalPercentage: "",
      },
    ],
  };
  const [userFormData, setUserFormData] = useState(initialState);
  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    phNumber: false,
  });

  const [userInput, setUserInput] = useState({
    name: false,
    email: false,
    phone: false,
  });

  useEffect(() => {
    dispatch(
      getAllReferrerList({
        clinicId,
        name: searchValue,
        status: ["Active"],
        currentPage: currentPage,
        limit: limit,
        token,
      })
    );
  }, [dispatch, clinicId, token, currentPage, limit, searchValue]);

  useEffect(() => {
    showTostifyMessageAndReset(
      createReferrerListSuccessMessage,
      showToastifySuccess,
      resetReferrerListCreateMessage
    );
    showTostifyMessageAndReset(
      createReferrerListErrorMessage,
      showToastifyError,
      resetReferrerListCreateMessage
    );
    showTostifyMessageAndReset(
      updateReferrerListSuccessMessage,
      showToastifySuccess,
      resetReferrerListUpdateMessage
    );
    showTostifyMessageAndReset(
      updateReferrerListErrorMessage,
      showToastifyError,
      resetReferrerListUpdateMessage
    );
    showTostifyMessageAndReset(
      deleteReferrerListSuccessMessage,
      showToastifySuccess,
      resetReferrerListDeleteMessage
    );
    showTostifyMessageAndReset(
      deleteReferrerListErrorMessage,
      showToastifyError,
      resetReferrerListDeleteMessage
    );
  }, [
    updateReferrerListSuccessMessage,
    updateReferrerListErrorMessage,
    createReferrerListSuccessMessage,
    createReferrerListErrorMessage,
    deleteReferrerListSuccessMessage,
    deleteReferrerListErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);

  useEffect(() => {
    dispatch(getServiceSlice({ status: ["Active"], token }));
  }, [dispatch, token]);

  const handleChanges = (e, names) => {
    switch (names) {
      case "searchUser":
        dispatch(getAllUsers({ searchKey: e.target.value, token }));
        setUserFormData((prev) => ({ ...prev, phone: e.target.value }));
        break;
      default:
        setUserFormData((prev) => ({
          ...prev,
          [e.target.name]: e.target.value,
        }));
    }
  };

  const handleSetPhoneNumber = (e, names) => {
    if (names === "phone") {
      setUserFormData({
        ...userFormData,
        phone: e.phone,
        patientId: e._id,
        name: e.name,
        email: e.email,
      });
      if (e.name) {
        setUserInput((prev) => ({
          ...prev,
          name: true,
        }));
      }
      if (e.email) {
        setUserInput((prev) => ({
          ...prev,
          email: true,
        }));
      }
    }
  };

  const handleModal = () => {
    setUserFormData(initialState);
    setshowModals(true);
    setIsMode(false);
  };

  const handleCloseModal = () => {
    setshowModals(false);
    setUserFormData(initialState);
    setIsMode(false);
    setSelectId(null);
  };

  const toggleDropdown = (id) => {
    setVisibleDropdown((prev) => (prev === id ? null : id));
  };

  const handleViewModal = (item) => {
    setViewModal(true);
    setUserFormData(item);
  };

  const handleAddField = () => {
    setUserFormData((prev) => ({
      ...prev,
      referalDetails: [
        ...prev.referalDetails,
        { serviceId: "", serviceName: "", referalPercentage: "" },
      ],
    }));
  };

  const handleRemoveField = (index) => {
    setUserFormData((prev) => {
      const updated = [...prev.referalDetails];
      updated.splice(index, 1);
      return { ...prev, referalDetails: updated };
    });
  };

  const handleSelectChange = (selectedOption, index) => {
    setUserFormData((prev) => {
      const updatedReferalDetails = [...prev.referalDetails];
      updatedReferalDetails[index] = {
        ...updatedReferalDetails[index],
        serviceId: selectedOption?.value,
        serviceName: selectedOption?.label,
      };
      return { ...prev, referalDetails: updatedReferalDetails };
    });
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    setSearchValue(searchTerm);
    dispatch(setCurrentPage(1));
    const statusFilter = searchTerm ? ["Active", "Inactive"] : ["Active"];
    dispatch(
      getAllReferrerList({
        name: searchTerm,
        clinicId,
        status: statusFilter,
        currentPage: 1,
        limit: limit,
        token,
      })
    );
  };

  const handlePageChange = (page) => {
    dispatch(setCurrentPage(page));
  };


  const handleLimitChange = (limit) => {
    dispatch(setPageLimit(limit));
  };

  const handleEdit = (item) => {
    setSelectId(item._id);
    setUserFormData((prev) => {
      if (isMode && selectId === item._id && prev.referalDetails?.length > 0) {
        return prev;
      }

      return {
        name: item?.userId?.name || "",
        email: item?.userId?.email || "",
        phone: item?.userId?.phone || "",
        status: item?.status || "Active",
        referalDetails:
          item?.referalDetails?.map((detail) => ({
            serviceId: detail?.serviceId._id || "",
            serviceName: detail?.serviceId?.serviceName || "",
            referalPercentage: detail?.referalPercentage || "",
          })) || [],
      };
    });

    setshowModals(true);
    setIsMode(true);
  };

  const handleDelete = (item) => {
    setSelectId(item?._id);
    setDeleteModal(true);
  };

  const handleDeleteReferrer = async () => {
    await dispatch(
      deleteReferrerList({
        clinicId,
        referrerId: selectId,
        token,
      })
    );
    await dispatch(
      getAllReferrerList({
        clinicId,
        status: ["Active"],
        currentPage: currentPage,
        limit: limit,
        token,
      })
    );
    setDeleteModal(false);
  };

  const handleAddUpdate = async (e) => {
    e.preventDefault();
    const { name, email, phNumber } = inputError;
    if (
      name ||
      email ||
      phNumber ||
      userFormData.referalDetails.some(
        ({ serviceId, referalPercentage }) => !serviceId || !referalPercentage
      )
    ) {
      return showToastifyError("Please fill all required fields.");
    }
    const referrerData = {
      clinicId,
      referalDetails: userFormData?.referalDetails,
    };
    const actionPayload =
      isMode && selectId
        ? {
          referrerId: selectId,
          ...referrerData,
          token,
          updatedData: {
            name: userFormData?.name,
            email: userFormData?.email,
            phone: userFormData?.phone,
            status: userFormData?.status,
          },
          updatedBy: userInfo?._id,
        }
        : {
          ...referrerData,
          name: userFormData?.name,
          email: userFormData?.email,
          phone: userFormData?.phone,
          status: userFormData?.status,
          token,
        };
    try {
      await dispatch(
        isMode && selectId
          ? updateReferrerList(actionPayload)
          : createReferrerList(actionPayload)
      );
      setshowModals(false);
      await dispatch(
        getAllReferrerList({
          clinicId: clinicId,
          status: ["Active"],
          currentPage: currentPage,
          limit: limit,
          token,
        })
      );
      setUserFormData({});
    } catch (error) {
      console.error("Error in Add/Update operation:", error);
    }
  };

  return (
    <>
      <>
        <div onClick={() => setVisibleDropdown(null)}>
          <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
            <button
              className="btn btn-primary btn-rounded me-4"
              onClick={() => handleModal()}
            >
              + Add
            </button>
            <div className="input-group search-area ms-auto d-inline-flex me-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search here"
                value={searchValue}
                onChange={handleSearch}
              />
            </div>
          </div>
          <Row>
            {referrerList && referrerList.length > 0 ? (
              referrerList.map((item, index) => (
                <Col md={4} key={index} className="position-relative">
                  <Card className={styles["cards"]}>
                    <h6 className="font-w700">
                      Name:{" "}
                      <span className="text-info fs-14 font-w600">
                        {item?.userId?.name}
                      </span>
                    </h6>
                    <h6 className="text-dark font-w700">
                      Email:{" "}
                      <span className="text-info fs-14 font-w600">
                        {item?.userId?.email}
                      </span>
                    </h6>
                    <h6 className="mt-1 text-dark font-w700">
                      Phone:{" "}
                      <span className="text-info fs-14 font-w600">
                        {item?.userId?.phone}
                      </span>
                    </h6>
                    <h6 className="mt-1 text-dark font-w700">
                      Status:{" "}
                      <span className="text-info fs-14 font-w600">
                        {item?.status}
                      </span>
                    </h6>
                    <div className={styles["service"]}>
                      <h6 className="text-dark font-w700">
                        Service:{" "}
                        <span className="text-info fs-14 font-w600">
                          {item?.referalDetails[0]?.serviceId?.serviceName}
                        </span>
                      </h6>
                      <h6 className="text-dark font-w700">
                        Referal Percentage:{" "}
                        <span className="text-info fs-14 font-w600">
                          {item?.referalDetails[0]?.referalPercentage}%
                        </span>
                      </h6>
                    </div>
                    <div
                      className={styles["view"]}
                      onClick={(e) => {
                        handleViewModal(item);
                      }}
                    >
                      View{" "}
                      {item?.referalDetails?.length > 1 &&
                        item?.referalDetails?.length - 1}{" "}
                      More Service Details
                    </div>
                    <div className={styles["dropdown"]}>
                      <div
                        className="position-relative"
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleDropdown(item._id);
                        }}
                      >
                        <BsThreeDotsVertical className="cursor-pointer text-dark fs-18" />
                        {visibleDropdown === item._id && (
                          <div className="dropdown-menu show position-absolute">
                            <button
                              className="dropdown-item"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleViewModal(item);
                              }}
                            >
                              <IoEyeSharp className="text-info me-2" /> View
                            </button>
                            <button
                              className="dropdown-item"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEdit(item);
                              }}
                            >
                              <FaPencilAlt className="text-secondary me-2" />
                              Edit
                            </button>
                            <button
                              className="dropdown-item"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(item);
                              }}
                            >
                              <FaTrashAlt className="text-danger me-2" />
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </Card>
                </Col>
              ))
            ) : (
              <Col>
                <h4 className="text-center my-5">{searchMessage}</h4>
              </Col>
            )}
          </Row>
          <CardPagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            limit={limit}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
          <ViewReferrerList
            viewModal={viewModal}
            setViewModal={setViewModal}
            referrerList={userFormData}
          />
          <AddUpdateReferrerList
            showModals={showModals}
            setshowModals={setshowModals}
            handleCloseModal={handleCloseModal}
            handleAddUpdate={handleAddUpdate}
            userFormData={userFormData}
            setUserFormData={setUserFormData}
            isMode={isMode}
            handleChanges={handleChanges}
            handleSelectChange={handleSelectChange}
            services={services}
            handleAddField={handleAddField}
            setInputError={setInputError}
            handleRemoveField={handleRemoveField}
            handleSetPhoneNumber={handleSetPhoneNumber}
            userInput={userInput}
          />
        </div>
        <Modal centered show={deleteModal} onHide={() => setDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Are You Sure Want to Delete it?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            After deleting, you won't be able to recover the data
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={() => setDeleteModal(false)}
              className="p-2"
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteReferrer}
              className="p-2"
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </>
  );
};

export default ReferrerList;
